import { AddressType, type Address } from "@/services/addresses/addressTypes";
import { fetchAddressList } from "@/services/addresses/addressApi";
import { ApiClient } from "@/services/apiClient/ApiClient";
import { UserNotFoundException } from "@/services/user/userExceptions";
import { type UserProfile } from "@/services/user/profile/profileTypes";
import type { UserId } from "@/services/user/userTypes";
import { type AxiosError } from "axios";
import { UserProfile_Schema } from "./profileSchema";

export type FetchUserProfileParams = { nickname: string } | { userId: UserId };

export async function fetchUserProfile(params: FetchUserProfileParams): Promise<UserProfile> {
  const url = `api-public/user/collector`;
  return ApiClient.getPublic<UserProfile>(url, params)
    .then((response) => UserProfile_Schema.parse(response.data))
    .catch((error: AxiosError) => {
      const status = error.response?.status;
      if (status === 404) {
        throw new UserNotFoundException();
      } else {
        throw error;
      }
    });
}

export async function fetchUserAddress(): Promise<Address | undefined> {
  // API returns a list, we want only one
  return fetchAddressList(AddressType.Personal).then((addressList) => {
    return addressList.shift();
  });
}
